@if (loading) {
  <div class="spinner-container">
    <div class="spinner"></div>
  </div>
} @else {
  <div class="info-screen-container">
    <app-info-screen
      [title]="copy.title"
      [highlightedText]="copy.highlightedText"
      [description]="copy.description"
      [listItems]="[]"
      [buttonText]="copy.buttonText"
      (buttonClicked)="handleButtonClick()"
      [contactLink]="'/help'"
      [steps]="copy.steps"
    ></app-info-screen>
  </div>
}
